
const HOSTS = ['a', 'b', 'c', 'd'];
import queryParamUpdater from '../../utils/queryParamUpdater';

function appendOptionsToUrl(url, options) {
    for (const optionName in options) {
        if (!options[optionName]) {
            continue;
        }

        if (url.includes(optionName)) {
            url = url.replace(optionName, options[optionName]);
        } else {
            url = queryParamUpdater(url, optionName, options[optionName]);
        }
    }
    return url;
}

export default function(type, layerId, urlPrototype, options, symbolLayerIdentifier = '') {
    const isWMS = type.startsWith('wms');
    const sourceId = 'raster-tiles-' + type;
    const style = {
        version: 8,
        sources: {
            [sourceId]: {
                type: 'raster',
                tileSize: isWMS ? 512 : 256,
                minzoom: 0,
                maxzoom: 22
            }
        },
        layers: [{
            id: `${layerId}${symbolLayerIdentifier}`,
            type: 'raster',
            source: sourceId
        }]
    };

    const url = appendOptionsToUrl(urlPrototype, options);

    style.sources[sourceId].tiles = HOSTS.map(host => {
        const urlWithHostname = url.replace('{s}', host);
        const separator = urlWithHostname.includes('?') ? '&' : '?';
        return `https://${urlWithHostname}${separator}key={key}`;
    });
    return style;
}



// WEBPACK FOOTER //
// ./map/tier/styleParts/rasterStylesFactory.js